import { css } from "styled-components";
export default css`
    .ant-btn-primary {
        background: #007097;
        border-color: #007097;
        color: #fff;
        
        &:not(:disabled):hover {
            border-color: #14A0FF;
            background-color: #14A0FF;
        }

        &:not(:disabled):active {
            border-color: #AAD370;
            background-color: #AAD370;
        }
    }
    .ant-btn[disabled] {
        border-color: #E5E5E5;
        background: #E5E5E5;
    }
`;